import React from 'react';
import classNames from 'classnames';


export const Select = ({
  label,
  id,
  className,
  attribute,
  options,
  required = false,
  disabled = false,
  autoFocus = false,
  setValue = () => null,
  rounded = 'rounded-none',
  shadow = 'shadow-sm',
  helpText,
  placeHolder = 'Bitte wählen',
  hasError,
  errorMessage,
  onSelect,
  defaultValue,
}) => {
  const inputClass = classNames([
    className,
    rounded,
    shadow,
    'custom-select w-full px-3 py-3 block border border-gray-300 text-base text-left placeholder-gray-400 appearance-none focus:outline-none focus:ring-brand-1 focus:border-brand-1',
    {
      'mt-1': label,
      'bg-gray-200 cursor-not-allowed': disabled,
      'border-red-600': hasError,
    },
  ]);

  return (
    <div className="relative">
      {label && (
        <label
          className="block mb-1 text-sm text-left font-semibold text-gray-700"
          htmlFor={id ? id : attribute}
        >
          {label}
          {required && ' *'}
        </label>
      )}
      <select
        id={id ? id : attribute}
        className={inputClass}
        name={attribute}
        disabled={disabled}
        autoFocus={autoFocus}
        required={required}
        onChange={(event) => {
          setValue(event.target.value);
          if (onSelect) {
            onSelect(event);
          }
        }}
      >
        {
          <option value={defaultValue ? defaultValue : ''}>
            {defaultValue ? defaultValue : placeHolder}
          </option>
        }

        {options?.map((option) => {
          return <option value={option?.value}>{option.label}</option>;
        })}
      </select>

      {hasError && errorMessage && (
        <div className="mt-2 text-xs text-red-600">{errorMessage}</div>
      )}
      {helpText && <div className="mt-2 text-xs text-gray-400">{helpText}</div>}
    </div>
  );
};
